/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u5m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What should I write in a 5-minute journaling session?`)
};

const es_timer_u5m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué debería escribir en una sesión de journaling de 5 minutos?`)
};

const de_timer_u5m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was sollte ich in einer 5-minütigen Journaling-Session schreiben?`)
};

const nl_timer_u5m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat moet ik schrijven in een journaling-sessie van 5 minuten?`)
};

const fr_timer_u5m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que faut-il écrire pendant une session de journaling de 5 minutes ?`)
};

const it_timer_u5m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa dovrei scrivere in una sessione di journaling di 5 minuti?`)
};

const pt_br2_timer_u5m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que devo escrever em uma sessão de journaling de 5 minutos?`)
};

const pt_timer_u5m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que devo escrever numa sessão de diário de 5 minutos?`)
};

const ja_timer_u5m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5分間のジャーナリングでは何を書けばいいですか？`)
};

const zh_timer_u5m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5分钟日记应该写些什么？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u5m_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u5m_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u5m_faq4_q", locale)
	if (locale === "en") return en_timer_u5m_faq4_q(inputs)
	if (locale === "es") return es_timer_u5m_faq4_q(inputs)
	if (locale === "de") return de_timer_u5m_faq4_q(inputs)
	if (locale === "nl") return nl_timer_u5m_faq4_q(inputs)
	if (locale === "fr") return fr_timer_u5m_faq4_q(inputs)
	if (locale === "it") return it_timer_u5m_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u5m_faq4_q(inputs)
	if (locale === "pt") return pt_timer_u5m_faq4_q(inputs)
	if (locale === "ja") return ja_timer_u5m_faq4_q(inputs)
	return zh_timer_u5m_faq4_q(inputs)
};